module.exports = __webpack_public_path__ + "media/images/checkout/challenger/learn_more_4-f85e5b9573763648cdab3c64b75deef2.png";